import styled from "@emotion/styled";

const Label = styled.label(({ theme }) => ({
  ...theme.fonts.body,
  display: "block",
  fontSize: theme.fontSizes.sm,
  fontWeight: "700",
  width: "auto",
  "&>small": {
    fontSize: "80%",
  },
  "&>small, &>span": {
    fontWeight: "normal",
  },
}));

export { Label };
